
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgXCloseBtn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 55,
  height: 55,
  viewBox: "0 0 120 120",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M60 14.2c25.252 0 45.8 20.548 45.8 45.8S85.252 105.8 60 105.8 14.2 85.252 14.2 60 34.748 14.2 60 14.2Z",
  fill: "var(--theme-light, #f9f3fb)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M74.284 74.284 46 46M45.716 74.284 74 46",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"55\" height=\"55\" viewBox=\"0 0 120 120\" fill=\"none\">\r\n  <path d=\"M60 14.2002C85.2517 14.2002 105.8 34.7483 105.8 60C105.8 85.2517 85.2517 105.8 60 105.8C34.7483 105.8 14.2002 85.2517 14.2002 60C14.2002 34.7483 34.7483 14.2002 60 14.2002Z\" fill=\"var(--theme-light, #f9f3fb)\" stroke-width=\"4.4\"/>\r\n  <path d=\"M74.2843 74.284L46 45.9998\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <path d=\"M45.7157 74.2843L74 46\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/x-close_btn.f164094d28b2b56d4ca4bca906782dc0.svg"),
        {
          React: SvgXCloseBtn,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      